/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconEyeDotted = createReactComponent("outline", "eye-dotted", "IconEyeDotted", [["path", { "d": "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M21 12h.01", "key": "svg-1" }], ["path", { "d": "M3 12h.01", "key": "svg-2" }], ["path", { "d": "M5 15h.01", "key": "svg-3" }], ["path", { "d": "M5 9h.01", "key": "svg-4" }], ["path", { "d": "M19 15h.01", "key": "svg-5" }], ["path", { "d": "M12 18h.01", "key": "svg-6" }], ["path", { "d": "M12 6h.01", "key": "svg-7" }], ["path", { "d": "M8 17h.01", "key": "svg-8" }], ["path", { "d": "M8 7h.01", "key": "svg-9" }], ["path", { "d": "M16 17h.01", "key": "svg-10" }], ["path", { "d": "M16 7h.01", "key": "svg-11" }], ["path", { "d": "M19 9h.01", "key": "svg-12" }]]);

export { IconEyeDotted as default };
//# sourceMappingURL=IconEyeDotted.mjs.map
